import {
  IResponse,
  IPageableResponse,
  IParkingEventsModel,
  IParkingEventsFilter,
} from '@aggregator/core';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ParkingEventsService {
  apiUrl = 'parkings/events';

  constructor(private service: BaseService) {}

  getAll(
    params: IParkingEventsFilter,
  ): Observable<IResponse<IPageableResponse<IParkingEventsModel>>> {
    return this.service.get<IResponse<IPageableResponse<IParkingEventsModel>>>(this.apiUrl, params);
  }

  getById(id: string): Observable<IResponse<IParkingEventsModel>> {
    return this.service.get<IResponse<IParkingEventsModel>>(this.apiUrl + '/' + id);
  }

  create(data: IParkingEventsModel): Observable<IResponse<IParkingEventsModel>> {
    return this.service.post<IResponse<IParkingEventsModel>>(this.apiUrl, data);
  }

  update(id: string, data: IParkingEventsModel): Observable<IResponse<IParkingEventsModel>> {
    return this.service.put<IResponse<IParkingEventsModel>>(this.apiUrl + '/' + id, data);
  }

  delete(id: string): Observable<IResponse<void>> {
    return this.service.delete<IResponse<void>>(this.apiUrl + '/' + id);
  }
}
